import {callLambda} from '@/lib/api/lambda';
import _ from 'lodash';

/**
 * 將自己加入棋院(分院)
 * @param {String} code 棋院代號
 * @returns {Array} Array
 */
function addSubAcademyUserByCode(code) {
  return callLambda({
    category: 'academy',
    method: 'post',
    apiName: 'addSubAcademyUserByCode',
    data: {code},
  }).then((res) => {
    return res.data;
  });
}

/**
 * 將自己移除棋院(分院)
 * @param {String} username 帳號
 * @param {String} subAcademyId 棋院id
 * @returns {Array} Array
 */
function deleteSubAcademyUser(username, subAcademyId) {
  return callLambda({
    category: 'academy',
    apiName: 'subacademy/user',
    method: 'DELETE',
    data: {
      username,
      subAcademyId,
    },
  }).then((res) => {
    return res.data;
  });
}

/**
 * 將使用者移除班級
 * @param {String} username 帳號
 * @param {String} classId 棋院id
 * @returns {Array} Array
 */
function deleteClassUser(username, classId) {
  return callLambda({
    category: 'academy',
    apiName: 'class/user',
    method: 'DELETE',
    data: {
      username,
      classId,
    },
  }).then((res) => {
    return res.data;
  });
}

/**
 * 取得班級資料
 * @returns {Promise} promise
 */
const getClasses = async () => {
  const res = await callLambda({
    category: 'academy',
    apiName: 'getUserClassList',
    method: 'get',
  });
  return res.data.data;
};

/**
 * 取得班級學生資料
 * @param {Number} classId 班級id
 * @returns {Promise} promise
 */
const getStudentsByClass = async ({classId, limit = 20, lastUsername}) => {
  const res = await callLambda({
    category: 'academy',
    method: 'get',
    apiName: 'getClassStudentList',
    params: {classId, limit, lastUsername},
  });
  return res.data.data;
};

/**
 * 取得棋院統計資料
 * @returns {Promise} promise
 */
async function getAcademyStatistic() {
  const res = await callLambda({
    category: 'academy',
    method: 'get',
    apiName: 'subacademy/statistic',
  });
  return res.data;
}

/**
 * 取得老師統計資料
 * @returns {Promise} promise
 */
async function getTeacherStatistic() {
  const res = await callLambda({
    category: 'academy',
    method: 'get',
    apiName: 'teacher/statistic',
  });
  return res.data;
}

/**
 * 搜尋班級學生資料
 * @param {String} keyword keyword
 * @returns {Promise} promise
 */
const searchStudent = async ({keyword}) => {
  const res = await callLambda({
    category: 'academy',
    method: 'get',
    apiName: 'management/search-student',
    params: {keyword: keyword?.trim()},
  });
  return res.data;
};

/**
 * 取得該 學生 對應的 學習任務
 * @param {Number} rank rank
 * @param {Number} batch batch
 * @param {String} username username
 * @returns {Promise} promise
 */
const getStudentStudyTask = _.memoize(async ({rank, batch, username}) => {
  const res = await callLambda({
    category: 'academy',
    method: 'get',
    apiName: 'management/student-study-task',
    params: {rank, batch, username},
  });
  return res.data;
});

/**
 * 取得該 學生 學習任務歷程
 * @param {Number} rank rank
 * @param {Number} batch batch
 * @param {String} username username
 * @returns {Promise} promise
 */
const getStudentStudyTaskRecords = _.memoize(
  async ({username, startTime, endTime, isAscending}) => {
    const res = await callLambda({
      category: 'academy',
      method: 'get',
      apiName: 'management/student-study-task-records',
      params: {username, startTime, endTime, isAscending},
    });
    return res.data;
  }
);

export default {
  addSubAcademyUserByCode,
  deleteSubAcademyUser,
  deleteClassUser,
  getClasses,
  getStudentsByClass,
  getAcademyStatistic,
  getTeacherStatistic,
  searchStudent,
  getStudentStudyTask,
  getStudentStudyTaskRecords,
};
